import { render, staticRenderFns } from "./videoPage.vue?vue&type=template&id=28489c44&scoped=true"
import script from "./videoPage.vue?vue&type=script&lang=js"
export * from "./videoPage.vue?vue&type=script&lang=js"
import style0 from "./videoPage.scss?vue&type=style&index=0&id=28489c44&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28489c44",
  null
  
)

export default component.exports